import { useEffect, useState } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { ProductCards } from "../ProductCards/ProductCards";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles.css";
import { useTranslation } from "react-i18next";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useUID } from "../../context/UIDContext";

export const ProductRecommendation = ({
  skinDiseaseDetected,
  getRecommendations,
  onBackClick,
}) => {
  const { t } = useTranslation("recommendation");
  const [products, setProducts] = useState(null);
  const { uid } = useUID();
  const trackEvent = useAmplitude();

  useEffect(() => {
    getRecommendations().then((res) => {
      if (res) {
        setProducts(res);
      }
    });
  }, [getRecommendations]);

  // Track user visits Product Recomandation Page
  useEffect(() => {
    // Track user visits Results Page
    trackEvent("webapp_user_visited_products_page", { uid: uid });
    trackEvent("webapp_user_visited_last_page", {
      uid: uid,
      lastPageName: "products",
    });
  }, [uid, trackEvent]);

  return (
    <div className="product-recommend">
      <div className="logo-bar">
        <img className="logo-img" src="logo.png" alt="Logo" />
        <IoChevronBackOutline
          className="back-icon"
          onClick={() => onBackClick()}
        />
      </div>
      <div className="product-individual">
        <h4 className="page-info">{t("title-1")}</h4>
        <h4 className="page-info">{t("title-2")}</h4>
      </div>
      {products ? (
        <>
          {Object.entries(products).map(
            ([categoryName, categorizedProducts]) => (
              <div key={categoryName} className="products-category-wrapper">
                <h4 className="products-title">{categoryName}</h4>
                <ProductCards
                  key={categoryName}
                  products={categorizedProducts}
                />
              </div>
            ),
          )}
        </>
      ) : (
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
            color: "#000",
          }}
        >
          <CircularProgress color="inherit" />
        </div>
      )}
      {/* NOTE: They may use it later, therefore hiding for now
      {skinDiseaseDetected && (
        <div className="bottom-derma2go-text">
          <img src="derma2go-logo.png" alt="Derma2Go" width={100} />
          <p className="derma-text">{t("derma2-go-info")}</p>
          <button
            className="derma2go-button"
            onClick={() => {
              trackEvent("webapp_user_clicked_derma2go", { uid: uid });
              const newWindow = window.open(
                "https://www.derma2go.com/de/",
                "_blank",
                "noopener,noreferrer",
              );
              if (newWindow) newWindow.opener = null;
            }}
          >
            {t("derma2go-button-text")}
          </button>
        </div>
      )} */}
    </div>
  );
};
